import * as React from "react";
const SvgBorder = (props) => /* @__PURE__ */ React.createElement("svg", { style: {
  transform: "rotate(-90deg)"
}, width: 44, height: 44, ...props }, /* @__PURE__ */ React.createElement("circle", { className: "progress-ring__circle", strokeWidth: 2, cx: 22, cy: 22, r: 20, fill: "transparent", strokeLinecap: "round", strokeDasharray: 124 }));
export default SvgBorder;
